import React from 'react';
import styles from '../styles/Contact.module.css';

function Contact() {
    return (
        <section className={styles.container}>
            <h2 className={styles.title}>CONTACT</h2>
            <div className={styles.contactList}>
                {/* 問い合わせリンク */}
                <a href="/contact" className={styles.contactItem}>
                    <div className={styles.cornerTL}></div>
                    <div className={styles.cornerTR}></div>
                    <div className={styles.cornerBL}></div>
                    <div className={styles.cornerBR}></div>
                    <span className={styles.label}>お気軽にご相談ください</span>
                    <span className={styles.arrow}>＞</span>
                    <span className={styles.action}>問い合わせ</span>
                </a>

                {/* 採用リンク */}
                <a href="/recruit" className={styles.contactItem}>
                    <div className={styles.cornerTL}></div>
                    <div className={styles.cornerTR}></div>
                    <div className={styles.cornerBL}></div>
                    <div className={styles.cornerBR}></div>
                    <span className={styles.label}>採用について</span>
                    <span className={styles.arrow}>＞</span>
                    <span className={styles.action}>採用ページへ</span>
                </a>
            </div>
        </section>
    );
}

export default Contact;
